function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import { recalculateOrderFormValues } from '../../helpers/recalculateOrderHelper';
import { getOrdersBySide, getQuantityForPrice, getValuesFromDealValues } from '../../helpers/orderHelper';
import { actionTypes } from 'redux-form';
import { getPriceDataForPresetAndCustomValuesSelector, getQuantityDataForPresetAndCustomValuesSelector } from '../../redux/selectors/buySellSelectors';
import { BUY_SELL_LAYOUTS } from '../../components/Retail/RetailBuySell/BuySell/BuySellLayoutTypes';
import config from '../../config';

/**
 * Middleware for calculating order fee for 'RetailOrderOverviewComponent.js'
 */
var orderFeeMiddleware = function orderFeeMiddleware(store) {
  return function (next) {
    return function (action) {
      var _store$getState = store.getState(),
        form = _store$getState.form,
        level2 = _store$getState.apexCore.level2;
      if (isFeeShouldBeRecalculated(action)) {
        var buySellFormIsInitialized = !!form.buySell;
        var entryForm = {};
        if (buySellFormIsInitialized) {
          entryForm = form.buySell;
          var selectedValue = getPriceAndQuantityForRequest(entryForm, store.getState(), action);

          // This calculation is duplicated in RetailOrderOverviewContainer
          var _config$OrderCalcBuff = config.OrderCalcBuffer;
          _config$OrderCalcBuff = _config$OrderCalcBuff === undefined ? {} : _config$OrderCalcBuff;
          var quantityBuffer = _config$OrderCalcBuff.quantityBuffer;
          var side = entryForm.values.side;
          var orders = getOrdersBySide(side, level2);
          var limitPrice = getQuantityForPrice(0, quantityBuffer, orders, false, side).LimitPrice;
          var updatedForm = Object.assign({}, entryForm.values, _defineProperty({
            limitPrice: limitPrice
          }, action.meta.field, action.payload));
          updatedForm.quantity = selectedValue.quantity;
          recalculateOrderFormValues(store, {
            form: updatedForm,
            formName: 'buySell',
            orders: orders
          });
        }
      }
      return next(action);
    };
  };
};
export var getPriceAndQuantityForRequest = function getPriceAndQuantityForRequest(form, state) {
  var action = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    meta: {}
  };
  var isPricePerUnitForm = form.values.layoutType === BUY_SELL_LAYOUTS.PRICE_PER_UNIT;
  var dealValues = isPricePerUnitForm ? getQuantityDataForPresetAndCustomValuesSelector(state, form.values.side) : getPriceDataForPresetAndCustomValuesSelector(state, form.values.side);
  var selectedValue = {
    price: '0',
    quantity: '0'
  };
  if (action.meta.field === 'instrument') {
    selectedValue = getValuesFromCustomChange(form, action);
  }

  // switch to `deal values` radio position
  else if (action.meta.field === 'amountRadio' && action.payload !== 'custom') {
    var fieldToSearch = isPricePerUnitForm ? 'quantity' : 'price';
    selectedValue = getValuesFromDealValues(dealValues, action.payload, fieldToSearch);
  }

  // switch to `custom` radio position
  else if (action.meta.field === 'amountRadio' && action.payload === 'custom') {
    selectedValue = getValuesFromCustomChange(form, action);
  }

  // sync `price` and `quantity` if `price` or `quantity` is changed
  else if (action.meta.field === 'price' || action.meta.field === 'quantity') {
    selectedValue = getValuesFromCustomChange(form, action);
  }
  return selectedValue;
};
var getValuesFromCustomChange = function getValuesFromCustomChange(_ref, action) {
  var values = _ref.values;
  var field = action.meta.field;
  return {
    price: field === 'price' ? action.payload : values.price,
    quantity: field === 'quantity' ? action.payload : values.quantity
  };
};
var isFeeShouldBeRecalculated = function isFeeShouldBeRecalculated(action) {
  return action.type === actionTypes.CHANGE && action.meta.field !== 'fee' && action.meta.field !== 'responseMessage' && action.meta.form === 'buySell';
};
export default orderFeeMiddleware;